// import React from 'react'

const AddCart = () => {
  return (
    <div>Cart section</div>
  )
}
export default AddCart;